<template>
  <div>
    <Base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-info">
      <b-row class="align-items-center">
        <b-col>
          <h6 class="h2 text-white d-inline-block mb-0">Sync MyUnila Gateway</h6>
          <p class="text-white-50 mb-0 mt-1">Sinkronisasi data alumni, tracer, DUDI, & UMR ke <code class="text-white">my.unila.ac.id/gateway/api-service</code></p>
        </b-col>
        <b-col cols="auto">
          <b-button variant="light" size="sm" @click="openSettings" class="font-weight-bold">
            <i class="fa fa-cog mr-1"></i> Pengaturan API
          </b-button>
        </b-col>
      </b-row>
    </Base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="6">
          <b-card>
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="h3 mb-0"><i class="ni ni-cloud-download-95 text-primary mr-2"></i>Pull Alumni</h5>
                <span class="badge" :class="myunilaPullRunning ? 'badge-warning' : 'badge-light'">{{ myunilaPullRunning ? 'Running' : 'Idle' }}</span>
              </div>
            </template>
            <p class="text-muted small">Tarik data alumni dari MyUnila gateway ke database lokal.</p>
            <b-form-group label="Tahun Lulus" label-size="sm">
              <b-form-select v-model="myunilaPullTahun" :options="tahunOptions" size="sm"></b-form-select>
            </b-form-group>
            <b-form-group label="Program Studi (opsional)" label-size="sm">
              <b-form-select v-model="myunilaPullProdi" :options="prodiOptions" size="sm"></b-form-select>
            </b-form-group>
            <b-button variant="primary" size="sm" @click="triggerMyunilaPull" :disabled="myunilaPullRunning || !myunilaPullTahun">
              <i class="fa fa-play mr-1"></i> Jalankan
            </b-button>
          </b-card>
        </b-col>

        <b-col xl="6">
          <b-card>
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="h3 mb-0"><i class="ni ni-cloud-upload-96 text-success mr-2"></i>Push Hasil Tracer</h5>
                <span class="badge" :class="myunilaPushRunning ? 'badge-warning' : 'badge-light'">{{ myunilaPushRunning ? 'Running' : 'Idle' }}</span>
              </div>
            </template>
            <p class="text-muted small">Kirim best-submission tracer ke MyUnila <code>/v1/tracer/hasil_tracer</code>. Sudah pernah sync = PUT update.</p>
            <b-form-group label="Tahun Lulus" label-size="sm">
              <b-form-select v-model="myunilaPushTahun" :options="tahunOptions" size="sm"></b-form-select>
            </b-form-group>
            <b-form-checkbox v-model="myunilaPushDryRun" class="mb-3" size="sm">
              Dry run (preview tanpa kirim)
            </b-form-checkbox>
            <b-button variant="success" size="sm" @click="triggerMyunilaPush" :disabled="myunilaPushRunning || !myunilaPushTahun">
              <i class="fa fa-play mr-1"></i> Jalankan
            </b-button>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col xl="6">
          <b-card>
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="h3 mb-0"><i class="ni ni-money-coins text-warning mr-2"></i>Push Data UMR</h5>
                <span class="badge" :class="myunilaUmrRunning ? 'badge-warning' : 'badge-light'">{{ myunilaUmrRunning ? 'Running' : 'Idle' }}</span>
              </div>
            </template>
            <p class="text-muted small">Kirim data UMR wilayah ke MyUnila <code>/v1/tracer/umr_wilayah</code>.</p>
            <b-form-group label="Tahun Anggaran" label-size="sm">
              <b-form-select v-model="myunilaUmrTahun" :options="umrTahunOptions" size="sm"></b-form-select>
            </b-form-group>
            <b-form-checkbox v-model="myunilaUmrDryRun" class="mb-3" size="sm">
              Dry run
            </b-form-checkbox>
            <b-button variant="warning" size="sm" @click="triggerMyunilaUmr" :disabled="myunilaUmrRunning">
              <i class="fa fa-play mr-1"></i> Jalankan
            </b-button>
          </b-card>
        </b-col>

        <b-col xl="6">
          <b-card>
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="h3 mb-0"><i class="ni ni-building text-info mr-2"></i>Push Hasil DUDI</h5>
                <span class="badge" :class="myunilaDudiRunning ? 'badge-warning' : 'badge-light'">{{ myunilaDudiRunning ? 'Running' : 'Idle' }}</span>
              </div>
            </template>
            <p class="text-muted small">Kirim survei DUDI ke <code>/v1/tracer/hasil_tracer_atasan</code>.<br>
              <span class="text-danger"><i class="fa fa-exclamation-triangle mr-1"></i>Pastikan Push Hasil Tracer sudah dijalankan dulu</span> (atasan butuh FK <code>id_hasil_tracer_study</code>).</p>
            <b-form-group label="Tahun Lulus" label-size="sm">
              <b-form-select v-model="myunilaDudiTahun" :options="tahunOptions" size="sm"></b-form-select>
            </b-form-group>
            <b-form-checkbox v-model="myunilaDudiDryRun" class="mb-3" size="sm">
              Dry run
            </b-form-checkbox>
            <b-button variant="info" size="sm" @click="triggerMyunilaDudi" :disabled="myunilaDudiRunning || !myunilaDudiTahun">
              <i class="fa fa-play mr-1"></i> Jalankan
            </b-button>
          </b-card>
        </b-col>
      </b-row>

      <!-- Settings Modal -->
      <b-modal ref="settings-modal" title="Pengaturan API MyUnila Gateway" size="lg" hide-footer>
        <p class="text-muted small mb-3">
          Endpoint: <code>my.unila.ac.id/gateway/api-service</code>. Auth via JWT 1 jam.
          <span v-if="settingsLoaded.myunila">Sumber: <strong>{{ settingsLoaded.myunila.password.is_set ? (settingsLoaded.myunila.password.source === 'database' ? 'Database (UI)' : 'Env file') : 'Belum diset' }}</strong></span>
        </p>
        <b-form-group label="Base URL" label-size="sm">
          <b-form-input v-model="settingsDraft.myunila.base_url" size="sm" placeholder="https://my.unila.ac.id/gateway/api-service"></b-form-input>
        </b-form-group>
        <b-form-group label="ID Aplikasi (UUID)" label-size="sm">
          <b-form-input v-model="settingsDraft.myunila.id_aplikasi" size="sm" placeholder="UUID dari tim MyUnila"></b-form-input>
        </b-form-group>
        <b-form-group label="Username" label-size="sm">
          <b-form-input v-model="settingsDraft.myunila.username" size="sm"></b-form-input>
        </b-form-group>
        <b-form-group label="Password" label-size="sm" :description="settingsLoaded.myunila && settingsLoaded.myunila.password.is_set ? 'Sudah terisi. Kosongkan kalau tidak ingin ubah.' : 'Belum diisi.'">
          <b-form-input v-model="settingsDraft.myunila.password" type="password" size="sm" :placeholder="settingsLoaded.myunila && settingsLoaded.myunila.password.is_set ? '••••••••' : 'password'" autocomplete="new-password"></b-form-input>
        </b-form-group>
        <b-form-group label="ID Creator (UUID)" label-size="sm" description="UUID identitas aplikasi tracer di MyUnila — wajib di setiap POST/PUT.">
          <b-form-input v-model="settingsDraft.myunila.id_creator" size="sm" placeholder="UUID dari tim MyUnila"></b-form-input>
        </b-form-group>

        <div class="d-flex justify-content-between mt-3">
          <b-button variant="outline-info" size="sm" @click="testConnection('myunila')" :disabled="testingProvider === 'myunila'">
            <i class="fa fa-plug mr-1"></i> {{ testingProvider === 'myunila' ? 'Testing...' : 'Test Connection' }}
          </b-button>
          <b-button variant="primary" size="sm" @click="saveSettings('myunila')" :disabled="savingSettings">
            <i class="fa fa-save mr-1"></i> Simpan
          </b-button>
        </div>

        <b-alert variant="warning" show class="mt-3 mb-0">
          <small>
            <i class="fa fa-shield-alt mr-1"></i>
            Password disimpan di database dengan enkripsi AES-256-CBC (Laravel APP_KEY).
            Tidak pernah ditampilkan kembali setelah disimpan — kalau lupa, isi ulang field password.
          </small>
        </b-alert>
      </b-modal>

      <!-- Progress Modal -->
      <b-modal ref="progress-modal" title="Progress Sync" :no-close-on-backdrop="true" hide-footer size="lg">
        <div v-if="activeLog">
          <div class="text-center mb-3">
            <span class="badge badge-lg" :class="statusBadge(activeLog.status)">{{ activeLog.status.toUpperCase() }}</span>
            <span class="ml-2 text-muted">{{ typeLabel(activeLog.type) }}</span>
          </div>
          <div class="d-flex justify-content-between mb-1">
            <small class="text-muted">
              Total data: <strong>{{ activeLog.total.toLocaleString('id-ID') }}</strong> &mdash;
              Diproses: <strong>{{ activeLog.processed.toLocaleString('id-ID') }}</strong>
            </small>
            <small class="text-muted">
              <strong>{{ (activeLog.progress_percent != null ? activeLog.progress_percent : (activeLog.total > 0 ? Math.round(activeLog.processed / activeLog.total * 100) : 0)) }}%</strong>
            </small>
          </div>
          <b-progress :value="activeLog.processed" :max="activeLog.total || 1" animated class="mb-3" style="height: 24px">
            <b-progress-bar :value="activeLog.processed" :variant="activeLog.status === 'failed' ? 'danger' : 'success'">
              {{ activeLog.processed.toLocaleString('id-ID') }} / {{ activeLog.total.toLocaleString('id-ID') }}
            </b-progress-bar>
          </b-progress>
          <b-row class="text-center mb-3">
            <b-col cols="6" sm="3" class="mb-2">
              <strong class="text-info h4 mb-0">{{ (activeLog.inserted_count || 0).toLocaleString('id-ID') }}</strong>
              <br><small class="text-muted"><i class="fa fa-plus-circle"></i> Insert</small>
            </b-col>
            <b-col cols="6" sm="3" class="mb-2">
              <strong class="text-primary h4 mb-0">{{ (activeLog.updated_count || 0).toLocaleString('id-ID') }}</strong>
              <br><small class="text-muted"><i class="fa fa-sync"></i> Update</small>
            </b-col>
            <b-col cols="6" sm="3" class="mb-2">
              <strong class="text-warning h4 mb-0">{{ activeLog.skipped_count.toLocaleString('id-ID') }}</strong>
              <br><small class="text-muted"><i class="fa fa-forward"></i> Skip</small>
            </b-col>
            <b-col cols="6" sm="3" class="mb-2">
              <strong class="text-danger h4 mb-0">{{ activeLog.failed_count.toLocaleString('id-ID') }}</strong>
              <br><small class="text-muted"><i class="fa fa-times-circle"></i> Gagal</small>
            </b-col>
          </b-row>
          <b-row class="text-center mb-3" v-if="activeLog.eta_seconds || activeLog.duration_ms">
            <b-col v-if="activeLog.eta_seconds && activeLog.status === 'running'"><small class="text-muted">Estimasi sisa: <strong>{{ formatEta(activeLog.eta_seconds) }}</strong></small></b-col>
            <b-col v-if="activeLog.duration_ms"><small class="text-muted">Durasi: <strong>{{ formatDuration(activeLog.duration_ms) }}</strong></small></b-col>
            <b-col><small class="text-muted">Total Sukses: <strong class="text-success">{{ activeLog.success_count.toLocaleString('id-ID') }}</strong></small></b-col>
          </b-row>
          <div v-if="activeLog.errors && activeLog.errors.length" class="mt-3">
            <h6>Error terbaru:</h6>
            <div class="bg-light p-2 rounded" style="max-height: 200px; overflow-y: auto; font-size: 0.8rem">
              <div v-for="(err, i) in activeLog.errors.slice(-10)" :key="i" class="mb-1">
                <strong>{{ err.npm || 'N/A' }}:</strong> {{ err.error }}
              </div>
            </div>
          </div>
          <div class="mt-3 text-right">
            <b-button v-if="activeLog.status === 'running' || activeLog.status === 'queued'" variant="danger" size="sm" @click="cancelSync">
              <i class="fa fa-stop mr-1"></i> Cancel
            </b-button>
            <b-button v-else variant="secondary" size="sm" @click="closeProgress">Tutup</b-button>
          </div>
        </div>
      </b-modal>

      <!-- History Table -->
      <b-row class="mt-4 mb-5">
        <b-col>
          <b-card no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
              <h5 class="h3 mb-0">Riwayat Sync</h5>
              <b-form-select v-model="historyFilter" :options="historyFilterOptions" size="sm" class="w-auto" @change="loadHistory"></b-form-select>
            </b-card-header>
            <b-card-body>
              <div class="table-responsive">
                <table class="table table-sm table-hover align-items-center">
                  <thead class="thead-light">
                    <tr>
                      <th>ID</th>
                      <th>Tipe</th>
                      <th>Status</th>
                      <th>Progress</th>
                      <th class="text-info">Insert</th>
                      <th class="text-primary">Update</th>
                      <th class="text-warning">Skip</th>
                      <th class="text-danger">Gagal</th>
                      <th>Mulai</th>
                      <th>Durasi</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="log in historyList" :key="log.id">
                      <td>{{ log.id }}</td>
                      <td>
                        <span class="badge" :class="typeBadge(log.type)">{{ typeShortLabel(log.type) }}</span>
                      </td>
                      <td><span class="badge" :class="statusBadge(log.status)">{{ log.status }}</span></td>
                      <td>
                        <small>{{ log.processed }} / {{ log.total }}</small>
                        <div class="progress" style="height:4px;">
                          <div class="progress-bar bg-success" :style="'width:' + (log.progress_percent || 0) + '%'"></div>
                        </div>
                      </td>
                      <td class="text-info">{{ log.inserted_count || 0 }}</td>
                      <td class="text-primary">{{ log.updated_count || 0 }}</td>
                      <td class="text-warning">{{ log.skipped_count }}</td>
                      <td class="text-danger">{{ log.failed_count }}</td>
                      <td><small>{{ formatDate(log.started_at) }}</small></td>
                      <td><small>{{ formatDuration(log.duration_ms) }}</small></td>
                      <td>
                        <template v-if="log.status === 'running' || log.status === 'queued'">
                          <b-button variant="outline-info" size="sm" @click="viewProgress(log.id)" v-b-tooltip.hover title="Lihat progress">
                            <i class="fa fa-eye"></i>
                          </b-button>
                          <b-button variant="outline-danger" size="sm" @click="stopSync(log.id)" v-b-tooltip.hover title="Stop sync" class="ml-1" :disabled="cancellingId === log.id">
                            <i class="fa fa-stop"></i>
                          </b-button>
                        </template>
                        <span v-else-if="log.errors_count > 0" class="text-danger small">{{ log.errors_count }} errors</span>
                      </td>
                    </tr>
                    <tr v-if="!historyList.length">
                      <td colspan="11" class="text-center text-muted py-3">Belum ada riwayat sync</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseHeader from "@/components/admin/BaseHeader";
import SyncOneDataService from "@/services/sync-onedata.service";
import DataService from "@/services/data.service";

export default {
  components: { BaseHeader },
  data: function () {
    return {
      umrTahunOptions: [],

      // MyUnila Gateway
      myunilaPullTahun: new Date().getFullYear() - 1,
      myunilaPullProdi: null,
      myunilaPullRunning: false,
      myunilaPushTahun: new Date().getFullYear() - 1,
      myunilaPushDryRun: false,
      myunilaPushRunning: false,
      myunilaUmrTahun: null,
      myunilaUmrDryRun: false,
      myunilaUmrRunning: false,
      myunilaDudiTahun: new Date().getFullYear() - 1,
      myunilaDudiDryRun: false,
      myunilaDudiRunning: false,

      tahunOptions: [],
      prodiOptions: [{ value: null, text: "Semua Prodi" }],

      activeLog: null,
      activeLogId: null,
      pollTimer: null,
      cancellingId: null,

      // Settings modal
      settingsLoaded: { onedata: null, myunila: null },
      settingsDraft: {
        onedata: { base_url: '', id_aplikasi: '', username: '', password: '' },
        myunila: { base_url: '', id_aplikasi: '', username: '', password: '', id_creator: '' }
      },
      savingSettings: false,
      testingProvider: null,

      historyList: [],
      historyFilter: null,
      historyFilterOptions: [
        { value: null, text: "Semua" },
        { value: "pull_alumni_myunila", text: "Pull Alumni" },
        { value: "push_tracer_myunila", text: "Push Tracer" },
        { value: "push_umr_myunila", text: "Push UMR" },
        { value: "push_dudi_myunila", text: "Push DUDI" }
      ]
    };
  },
  created: function () {
    this.buildTahunOptions();
    this.buildUmrTahunOptions();
    this.loadProdi();
    this.loadHistory();
  },
  beforeDestroy: function () {
    this.stopPolling();
  },
  methods: {
    buildTahunOptions: function () {
      var currentYear = new Date().getFullYear();
      this.tahunOptions = [];
      for (var y = currentYear; y >= 2019; y--) {
        this.tahunOptions.push({ value: y, text: "Lulusan " + y });
      }
    },
    buildUmrTahunOptions: function () {
      var currentYear = new Date().getFullYear();
      this.umrTahunOptions = [{ value: null, text: "Semua Tahun" }];
      for (var y = currentYear + 1; y >= 2019; y--) {
        this.umrTahunOptions.push({ value: y, text: "Tahun " + y });
      }
    },
    loadProdi: function () {
      var self = this;
      DataService.getStudyPrograms().then(function (res) {
        var list = [{ value: null, text: "Semua Prodi" }];
        var arr = (res.data && res.data.studyPrograms) || res.data || [];
        if (!Array.isArray(arr)) arr = [];
        arr.forEach(function (p) {
          list.push({ value: p.id_program_studi, text: (p.jenjang || '') + ' - ' + p.nm_program_studi });
        });
        self.prodiOptions = list;
      }).catch(function (err) { console.error('loadProdi:', err); });
    },
    loadHistory: function () {
      var self = this;
      SyncOneDataService.history(this.historyFilter).then(function (res) {
        self.historyList = res.data || [];
        self.checkRunning();
      }).catch(function () {});
    },
    checkRunning: function () {
      var self = this;
      self.myunilaPullRunning = false;
      self.myunilaPushRunning = false;
      self.myunilaUmrRunning = false;
      self.myunilaDudiRunning = false;
      this.historyList.forEach(function (log) {
        if (log.status === 'running' || log.status === 'queued') {
          if (log.type === 'pull_alumni_myunila') self.myunilaPullRunning = true;
          if (log.type === 'push_tracer_myunila') self.myunilaPushRunning = true;
          if (log.type === 'push_umr_myunila') self.myunilaUmrRunning = true;
          if (log.type === 'push_dudi_myunila') self.myunilaDudiRunning = true;
        }
      });
    },
    isMyunila: function (type) {
      return typeof type === 'string' && type.indexOf('_myunila') !== -1;
    },
    typeLabel: function (type) {
      var labels = {
        'pull_alumni': 'Pull Alumni (OneData)',
        'push_tracer': 'Push Hasil Tracer (OneData)',
        'push_umr': 'Push UMR (OneData)',
        'push_dudi': 'Push DUDI (OneData)',
        'pull_alumni_myunila': 'Pull Alumni (MyUnila)',
        'push_tracer_myunila': 'Push Hasil Tracer (MyUnila)',
        'push_umr_myunila': 'Push UMR (MyUnila)',
        'push_dudi_myunila': 'Push DUDI (MyUnila)'
      };
      return labels[type] || type;
    },
    typeShortLabel: function (type) {
      if (type && type.indexOf('pull_alumni') === 0) return 'Pull';
      if (type && type.indexOf('push_tracer') === 0) return 'Tracer';
      if (type && type.indexOf('push_umr') === 0) return 'UMR';
      if (type && type.indexOf('push_dudi') === 0) return 'DUDI';
      return type || '-';
    },
    typeBadge: function (type) {
      if (type && type.indexOf('pull_alumni') === 0) return 'badge-primary';
      if (type && type.indexOf('push_tracer') === 0) return 'badge-success';
      if (type && type.indexOf('push_umr') === 0) return 'badge-warning';
      if (type && type.indexOf('push_dudi') === 0) return 'badge-info';
      return 'badge-secondary';
    },
    confirmAndRun: function (title, html, onConfirm) {
      this.$swal({
        title: title,
        html: html,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, Jalankan",
        cancelButtonText: "Batal",
        confirmButtonColor: "#11cdef",
        reverseButtons: true
      }).then(function (result) {
        if (result.value) onConfirm();
      });
    },
    runSync: function (type, params, runningKey) {
      var self = this;
      SyncOneDataService.trigger(type, params).then(function (res) {
        self[runningKey] = true;
        self.viewProgress(res.data.log_id);
        self.loadHistory();
      }).catch(function (err) {
        var msg = (err.response && err.response.data && err.response.data.message) || "Gagal memulai sync";
        self.$swal({ icon: "error", title: "Gagal", text: msg });
      });
    },
    triggerMyunilaPull: function () {
      var self = this;
      var prodiText = self.myunilaPullProdi
        ? (self.prodiOptions.find(function (o) { return o.value === self.myunilaPullProdi; }) || {}).text
        : "Semua Prodi";
      self.confirmAndRun(
        "Pull Alumni dari MyUnila Gateway?",
        "Tahun Lulus: <strong>" + self.myunilaPullTahun + "</strong><br>Prodi: <strong>" + prodiText + "</strong><br><br><small class='text-muted'>Endpoint MyUnila gateway. Pastikan kredensial sudah diisi di .env.</small>",
        function () {
          self.runSync("pull_alumni_myunila", {
            tahun: self.myunilaPullTahun,
            id_prodi: self.myunilaPullProdi
          }, "myunilaPullRunning");
        }
      );
    },
    triggerMyunilaPush: function () {
      var self = this;
      self.confirmAndRun(
        "Push Hasil Tracer ke MyUnila?",
        "Tahun Lulus: <strong>" + self.myunilaPushTahun + "</strong><br>Mode: <strong>" + (self.myunilaPushDryRun ? "Dry Run" : "Live") + "</strong><br><br><small class='text-muted'>POST /v1/tracer/hasil_tracer. Yang sudah pernah sync (id_tracer_myunila terisi) akan di-PUT update.</small>",
        function () {
          self.runSync("push_tracer_myunila", {
            tahun: self.myunilaPushTahun,
            dry_run: self.myunilaPushDryRun
          }, "myunilaPushRunning");
        }
      );
    },
    triggerMyunilaUmr: function () {
      var self = this;
      self.confirmAndRun(
        "Push Data UMR ke MyUnila?",
        "Tahun Anggaran: <strong>" + (self.myunilaUmrTahun || "Semua Tahun") + "</strong><br>Mode: <strong>" + (self.myunilaUmrDryRun ? "Dry Run" : "Live") + "</strong>",
        function () {
          var params = { dry_run: self.myunilaUmrDryRun };
          if (self.myunilaUmrTahun) params.tahun = self.myunilaUmrTahun;
          self.runSync("push_umr_myunila", params, "myunilaUmrRunning");
        }
      );
    },
    openSettings: function () {
      var self = this;
      SyncOneDataService.getSettings().then(function (res) {
        self.settingsLoaded = res.data;
        self.settingsDraft.myunila = {
          base_url: res.data.myunila.base_url || '',
          id_aplikasi: res.data.myunila.id_aplikasi || '',
          username: res.data.myunila.username || '',
          password: '',
          id_creator: res.data.myunila.id_creator || ''
        };
        self.$refs['settings-modal'].show();
      }).catch(function () {
        self.$swal({ icon: 'error', title: 'Gagal', text: 'Tidak bisa load settings' });
      });
    },
    saveSettings: function (provider) {
      var self = this;
      self.savingSettings = true;
      var payload = {};
      payload[provider] = self.settingsDraft[provider];
      SyncOneDataService.saveSettings(payload).then(function (res) {
        self.savingSettings = false;
        self.$swal({ icon: 'success', title: 'Tersimpan', text: 'Field updated: ' + (res.data.updated || []).join(', '), timer: 2000 });
        self.openSettings(); // reload status
      }).catch(function (err) {
        self.savingSettings = false;
        var msg = (err.response && err.response.data && err.response.data.message) || 'Gagal simpan';
        self.$swal({ icon: 'error', title: 'Gagal', text: msg });
      });
    },
    testConnection: function (provider) {
      var self = this;
      self.testingProvider = provider;
      // Simpan dulu sebelum test, supaya nilai yang baru di-isi langsung kepakai
      var payload = {};
      payload[provider] = self.settingsDraft[provider];
      SyncOneDataService.saveSettings(payload).then(function () {
        return SyncOneDataService.testConnection(provider);
      }).then(function (res) {
        self.testingProvider = null;
        self.$swal({
          icon: res.data.success ? 'success' : 'error',
          title: res.data.success ? 'Connection OK' : 'Connection Failed',
          text: res.data.message + (res.data.token_prefix ? '\nToken: ' + res.data.token_prefix : '')
        });
      }).catch(function (err) {
        self.testingProvider = null;
        var msg = (err.response && err.response.data && err.response.data.message) || 'Test gagal';
        self.$swal({ icon: 'error', title: 'Connection Failed', text: msg });
      });
    },
    triggerMyunilaDudi: function () {
      var self = this;
      self.confirmAndRun(
        "Push Hasil DUDI ke MyUnila?",
        "Tahun Lulus: <strong>" + self.myunilaDudiTahun + "</strong><br>Mode: <strong>" + (self.myunilaDudiDryRun ? "Dry Run" : "Live") + "</strong><br><br><small class='text-warning'>⚠ Pastikan tracer hasil sudah dipush ke MyUnila dulu — atasan butuh FK <code>id_hasil_tracer_study</code>.</small>",
        function () {
          self.runSync("push_dudi_myunila", {
            tahun: self.myunilaDudiTahun,
            dry_run: self.myunilaDudiDryRun
          }, "myunilaDudiRunning");
        }
      );
    },
    viewProgress: function (logId) {
      this.activeLogId = logId;
      this.pollStatus();
      this.$refs["progress-modal"].show();
      this.startPolling();
    },
    pollStatus: function () {
      var self = this;
      if (!this.activeLogId) return;
      SyncOneDataService.status(this.activeLogId).then(function (res) {
        self.activeLog = res.data;
        if (res.data.status !== 'running' && res.data.status !== 'queued') {
          self.stopPolling();
          self.loadHistory();
        }
      }).catch(function () {});
    },
    startPolling: function () {
      this.stopPolling();
      this.pollTimer = setInterval(this.pollStatus, 2000);
    },
    stopPolling: function () {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    cancelSync: function () {
      var self = this;
      if (!this.activeLogId) return;
      SyncOneDataService.cancel(this.activeLogId).then(function () {
        self.pollStatus();
      }).catch(function () {});
    },
    stopSync: function (logId) {
      var self = this;
      self.$swal({
        title: "Stop sync ini?",
        text: "Sync ID #" + logId + " akan dihentikan. Job worker akan berhenti pada iterasi berikutnya.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, stop",
        cancelButtonText: "Batal",
        confirmButtonColor: "#f5365c",
        reverseButtons: true
      }).then(function (result) {
        if (!result.value) return;
        self.cancellingId = logId;
        SyncOneDataService.cancel(logId).then(function () {
          self.cancellingId = null;
          self.loadHistory();
          self.$swal({ icon: "success", title: "Sync di-stop", timer: 1500, showConfirmButton: false });
        }).catch(function (err) {
          self.cancellingId = null;
          var msg = (err.response && err.response.data && err.response.data.message) || "Gagal stop sync";
          self.$swal({ icon: "error", title: "Gagal", text: msg });
        });
      });
    },
    closeProgress: function () {
      this.stopPolling();
      this.$refs["progress-modal"].hide();
      this.activeLog = null;
      this.activeLogId = null;
      this.loadHistory();
    },
    statusBadge: function (status) {
      var map = {
        queued: "badge-info",
        running: "badge-warning",
        success: "badge-success",
        partial: "badge-warning",
        failed: "badge-danger",
        cancelled: "badge-secondary"
      };
      return map[status] || "badge-secondary";
    },
    formatDate: function (d) {
      if (!d) return "-";
      var dt = new Date(d);
      return dt.toLocaleDateString("id-ID") + " " + dt.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
    },
    formatDuration: function (ms) {
      if (!ms) return "-";
      if (ms < 1000) return ms + " ms";
      var s = Math.round(ms / 1000);
      if (s < 60) return s + " dtk";
      var m = Math.floor(s / 60);
      return m + " mnt " + (s % 60) + " dtk";
    },
    formatEta: function (seconds) {
      if (!seconds || seconds <= 0) return "-";
      if (seconds < 60) return "~" + Math.round(seconds) + " dtk";
      return "~" + Math.round(seconds / 60) + " mnt";
    }
  }
};
</script>

